import { FundHoldingEntity } from '../../Entities/Fund.Holding.Entity';
import { SmartDBTxApiCalls } from '../index.exports.BtnHandlers.TxApiCalls';

export class FundHoldingTxApiCalls extends SmartDBTxApiCalls {
    protected static _Entity = FundHoldingEntity;

    // #region api tx

    // #endregion api tx
}
